import React, { useMemo } from "react";
import { useSelector } from "react-redux";
import PowerBiReports from "../common/components/PowerBiReports";
import config from "../config";
import { enums } from "../common/lib";
import SkipTrace from "./SkipTrace";

/**
 * PowerBI Reports Component
 */
export default () => {
    const { userOrganisations } = useSelector((state) => state);

    const res = useMemo(() => {
        // If stellantis org show everything

        if (
            userOrganisations?.item?.id ===
            enums.organisationIds.stellantisFinanceFrance
        ) {
            return config.powerBI.reports;
        }
        
        // If volkswagen, add Skip Trace tab
         
        if (
            userOrganisations?.item?.id ===
            enums.organisationIds.volkswagen
        ) {
            return [
                ...config.powerBI.reports,
                {
                    label: "Skip Trace",
                    isCustom: true,
                    component: <SkipTrace />
                }
            ];
        } 
    

        /** Check for funders  */
        return config.powerBI.reports.filter(
            (item) => item.label !== "Audit Outcome"
        );
        // config.powerBI.reports.filter(
        //     (item) => item.label !== "Funder Connect"
        // );
    }, [userOrganisations, config.powerBI.reports]);

    return (
        <PowerBiReports page="reports" reportTabs={[...res]} reportList={res} />
    );
};
